<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    version="1.1"
    id="svg4"
    sodipodi:docname="heart.svg"
    inkscape:version="1.0.1 (3bc2e813f5, 2020-09-07)"
    v-on="$listeners"
  >
    <metadata id="metadata10">
      <rdf:RDF>
        <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs8" />
    <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      id="namedview6"
      showgrid="false"
      inkscape:zoom="3.9627443"
      inkscape:cx="41.879752"
      inkscape:cy="33.308489"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="svg4"
    />
    <g
      id="g859"
      transform="matrix(0.0660967,0,0,0.0660967,-35.723753,-10.690075)"
      style="fill-opacity:1"
      fill="currentColor"
    >
      <path
        id="path835"
        style="fill-opacity:1;stroke-width:1"
        d="m 669.3125,163.44774 c -68.925,0 -124.99441,56.06942 -124.99441,124.99442 0,63.30509 47.33015,115.64812 108.44668,123.78289 -0.49866,-4.52641 -0.79783,-9.11299 -0.79783,-13.77008 0,-5.60285 0.49367,-11.0788 1.21153,-16.48861 -44.7071,-7.69909 -78.86763,-46.6528 -78.86763,-93.5242 0,-52.383 42.61866,-95.00167 95.00166,-95.00167 47.55963,0 86.94698,35.17359 93.81969,80.84745 4.54676,-0.50324 9.15047,-0.82738 13.82917,-0.82738 5.61991,0 11.12212,0.48936 16.54773,1.21153 C 786.62741,212.20732 733.58042,163.44774 669.3125,163.44774 Z"
      />
      <path
        d="m 776.01103,272.49922 c -68.925,0 -125,56.075 -125,125 0,68.925 56.075,125 125,125 68.925,0 125,-56.075 125,-125 0,-68.925 -56.075,-125 -125,-125 z m 0,220 c -52.383,0 -95,-42.617 -95,-95 0,-52.383 42.617,-95 95,-95 52.383,0 95,42.617 95,95 0,52.383 -42.617,95 -95,95 z"
        id="path837"
        style="fill-opacity:1"
      />
      <circle
        cx="806.01105"
        cy="372.49924"
        r="15"
        id="circle839"
        style="fill-opacity:1"
      />
      <circle
        cx="746.01105"
        cy="372.49924"
        r="15"
        id="circle841"
        style="fill-opacity:1"
      />
      <path
        d="m 805.40503,420.31122 c -16.207,16.207 -42.58,16.207 -58.787,0 -5.857,-5.858 -15.355,-5.858 -21.213,0 -5.858,5.858 -5.858,15.355 0,21.213 13.952,13.953 32.279,20.929 50.606,20.929 18.327,0 36.654,-6.976 50.606,-20.929 5.858,-5.858 5.858,-15.355 0,-21.213 -5.857,-5.859 -15.355,-5.859 -21.212,0 z"
        id="path843"
        style="fill-opacity:1"
      />
      <circle
        cx="699.30511"
        cy="263.44351"
        r="15"
        id="circle845"
        style="fill-opacity:1"
      />
      <circle
        cx="639.30511"
        cy="263.44351"
        r="15"
        id="circle847"
        style="fill-opacity:1"
      />
      <path
        id="path849"
        style="fill-opacity:1;stroke-width:1"
        d="m 629.30247,313.44105 c -8.284,0 -15.01115,6.72714 -15.01115,15.01114 0,8.284 6.72715,14.98161 15.01115,14.98161 h 35.57761 c 5.4317,-11.01896 12.4261,-21.09157 20.7142,-29.99275 z"
      />
    </g>
  </svg>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FacesIcon extends Vue {}
</script>
